import { useState, useCallback } from 'react';
import { store as rtkStore } from "redux/store";
import { customerApi } from "redux/services/customerApi";

export const useLazyGetRetrivalQuery = (options) => {
    const { getRetrival } = customerApi.endpoints;
    const [result, setResult] = useState();
    const fetch = useCallback(async (params) => {
        const response = await rtkStore.dispatch(getRetrival.initiate(params, options));
        setResult(response);
        return response
    }, [options, getRetrival]);

    return  [
        fetch,
        result
    ];
};

export const useCreateChargebackMutation = () => {
    const { createChargeback } = customerApi.endpoints;
    const fetch = useCallback(async (body) => {
        return await rtkStore.dispatch(createChargeback.initiate(body));

    }, [createChargeback]);

    return [
        fetch,
    ];
};

export const useLazyGetCustomerCardInfoQuery = (options) => {
    const { getCustomerCardInfo } = customerApi.endpoints;
    const [result, setResult] = useState();
    const fetch = useCallback(async (params) => {
        const response = await rtkStore.dispatch(getCustomerCardInfo.initiate(params, options));
        setResult(response);
        return response
    }, [options, getCustomerCardInfo]);

    return  [
        fetch,
        result
    ];
};

export const useDeleteCustomerMutation = () => {
    const { deleteCustomer } = customerApi.endpoints;
    const [result, setResult] = useState();
    const fetch = useCallback(async (params) => {
        const response =  await rtkStore.dispatch(deleteCustomer.initiate({ params }));
        setResult(response);
        return response;
    }, [deleteCustomer]);

    return [
        fetch,
        result,
    ];
};
